<div class="form-input" appClickOutside (onClickOutSide)="show=false">
  <label *ngIf="label">{{ label | translate }} <span *ngIf="required">*</span></label>
  
  <div class="input">
    <div class="selector" (click)="show=!show" [attr.aria-expanded]="show" role="combobox">
      <span class="selected-value">{{ ((selected !== false && selected !== undefined || (type === 'boolean' && !selected)) ? (selected?.label ? translateKey + selected.label : (selected?.employee_id ? (selected|firstLastName) : (translateKey == '' ? selected.name : translateKey + selected))) : placeholder)|translate }}</span>
      <span class="chevron"><i [class]="'fa-solid ' + (show ? 'fa-chevron-up' : 'fa-chevron-down')"></i></span>
    </div>
    
    <div [class]="label ? 'sub-menu' : 'sub-menu nolabel'" [class.hide]="!show" role="listbox">
      <div class="item" 
           *ngFor="let item of options" 
           (click)="selectValue(item)"
           [class.selected]="selected === item"
           role="option"
           [attr.aria-selected]="selected === item">
        {{ translateKey + item.label | translate }}
      </div>
    </div>
  </div>

  <div class="errors" *ngIf="required && !selected">
    <i class="fa-regular fa-circle-exclamation"></i>
    <span>{{ 'common.form.error.required' | translate }}</span>
  </div>
</div>
